// src/components/Common/InfoPanel/InfoPanel.jsx
import React from 'react';
import './InfoPanel.less';

/**
 * Info panel component - receipt-style information container
 * Used for displaying session details in a clean, organized way
 * Following the design principles from the receipt UI
 */
const InfoPanel = ({ children, title = null, className = '' }) => {
  return (
    <div className={`info-panel ${className}`}>
      {title && <h3 className="info-panel__title">{title}</h3>}
      <div className="info-panel__content">
        {children}
      </div>
    </div>
  );
};

export default InfoPanel;
